const initialState = {
  report_data: null,
  isLoding : false
 
};

const ReportApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING":
      return {
        ...state,
        isLoding: action.payload
      };

    case "GET_EMPLOYEE_FOR_REPORT_SUCCESS":
      return {
        ...state,
        report_data: action.payload,
        error: null
      };
    case "GET_EMPLOYEE_FOR_REPORT_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "GENRATE_PF_ECR_REPORT_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "GENRATE_PF_ECR_REPORT_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };
    
    case "GENRATE_ESIC_REPORT_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "GENRATE_ESIC_REPORT_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

   


    default:
      return state;
  }
};

export default ReportApiReducer;

